import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { IOption } from '@shared/models/icommons.model';

@Component({
  selector: 'miq-mat-dropdown',
  templateUrl: './mat-dropdown.component.html',
  standalone: false,
})
export class MatDropdownComponent implements OnInit {
  @Input() confidentialityLevels: IOption[];
  @Input() value;
  @Input() key;
  @Input() pageType;
  @Output() fieldChange = new EventEmitter<any>();
  selectFormGroup: UntypedFormGroup;
  confidentialityFC = new UntypedFormControl();

  constructor() {
    this.selectFormGroup = new UntypedFormGroup({
      confidentialityFC: new UntypedFormControl(),
    });
  }

  ngOnInit() {
    if (this.value && this.key) {
      this.confidentialityFC.setValue(this.confidentialityLevels.find(f => f.key === this.key));
    } else {
      this.confidentialityFC.setValue(this.confidentialityLevels[0]);
    }
    this.confidentialityFC.valueChanges.subscribe(value => {
      this.fieldChange.emit(value);
    });
  }
}
